/* eslint-disable */
import { useState } from "react";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import BackButton from "../BackButton/BackButton";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import NewQueryPopup from "./NewQueryPopup";
import { ContentScoreHeaderStyle } from "./css";
import { useNavigate } from "react-router";

function ContentScoreHeader({ createQuery }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleNewQueryLoader = (state) => {
    setLoading(state);
  };
  const handlenavigateBack = () => {
    navigate("/ai-blog-generator");
  }

  return (
    <ContentScoreHeaderStyle>
      <Box className="ContentWrapper">
        <Typography component="h2">Content Queries</Typography>
        <Box className="BtnWrapper">
          <BackButton onClick={handlenavigateBack} sx={{ "& button": { marginBottom: "0 !important" } }} />
          <Button className="QueryBtn" onClick={handleOpen} disabled={loading}>
            {loading? <CircularProgress size={25} style={{ color: "#fff" }} /> :
            <><AutoFixHighIcon /> New query</>}
          </Button>
        </Box>
      </Box>
      <NewQueryPopup open={open} handleClose={handleClose} createQuery={createQuery} handleNewQueryLoader={handleNewQueryLoader} />
    </ContentScoreHeaderStyle>
  );
}

export default ContentScoreHeader;
